// src/pages/EditPost/index.jsx - 简化版
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Result, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import './index.css';

function EditPost() {
  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <div className="edit-post">
      <div className="container">
        <Result
          status="info"
          title="编辑功能开发中"
          subTitle={`您正在尝试编辑文章 ID: ${id}`}
          extra={[
            <Button 
              key="back" 
              type="primary"
              onClick={() => navigate(-1)}
              icon={<ArrowLeftOutlined />}
            >
              返回
            </Button>,
            <Button 
              key="archive"
              onClick={() => navigate('/archive')}
            >
              浏览归档
            </Button>
          ]}
        />
      </div>
    </div>
  );
}

export default EditPost;